export default __webpack_public_path__ + "static/media/chevron.9763e454.svg";